module.exports.flexCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

module.exports.flexCenterLeft = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
}

module.exports.flexCenterRight = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
}

module.exports.minHeight = {
  minHeight: '100vh'
}

module.exports.primaryTextColor = {
  color: '#408EBA'
}

module.exports.formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

module.exports.formItemLayoutReminder = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

module.exports.formItemLayoutInvoice = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

module.exports.formItemLayoutOffer = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

module.exports.formItemLayoutSearch = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};

module.exports.formItemLayoutReminderPayment = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};

module.exports.formItemLayoutForNewEvent = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

module.exports.nameStyle = {
  fontSize: "22px",
  fontWeight: "400",
}

module.exports.roleStyle = {
  color: "#777777",
  fontWeight: '400',
  marginTop: "-25px",
  fontSize: '13px',
}

module.exports.modalDiv = {
  width: '100%',
  maxHeight: '425px',
  overflow: 'auto',
}
